import type { SavedSimulationRow } from "api/simulation/simulationsList";

/** Dataset fijo para mockup / demos de UI (todos los estados del modelo). */
export const MOCK_SAVED_SIMULATIONS: SavedSimulationRow[] = [
  {
    id: "mock-draft-1",
    simulation_name: "Construcción — ajuste de política de cobertura",
    status: "draft",
    created_at: "2026-05-07T09:20:00.000Z",
    executed_at: null,
    closed_at: null,
    simulated_purchase_orders: [{ id: "m-po-1", document_number: "OC-SIM-78432" }],
  },
  {
    id: "mock-running-1",
    simulation_name: "Proyección Mayo–Julio (alta rotación)",
    status: "running",
    created_at: "2026-05-06T14:00:00.000Z",
    executed_at: "2026-05-07T11:03:22.000Z",
    closed_at: null,
    simulated_purchase_orders: [
      { id: "m-po-2", document_number: "OC-SIM-91002" },
      { id: "m-po-3", document_number: "OC-SIM-91003" },
      { id: "m-po-4", document_number: "OC-SIM-91004" },
    ],
  },
  {
    id: "mock-completed-1",
    simulation_name: "Baseline 2026 — validación con supply",
    status: "completed",
    created_at: "2026-05-01T08:45:00.000Z",
    executed_at: "2026-05-01T09:12:00.000Z",
    closed_at: "2026-05-01T16:30:00.000Z",
    simulated_purchase_orders: [
      { id: "m-po-5", document_number: "OC-SIM-66100" },
      { id: "m-po-6", document_number: "OC-SIM-66101" },
    ],
  },
  {
    id: "mock-failed-1",
    simulation_name: "Stress test — insumos discontinuos",
    status: "failed",
    created_at: "2026-04-28T16:10:00.000Z",
    executed_at: "2026-04-28T16:11:40.000Z",
    closed_at: null,
    simulated_purchase_orders: [{ id: "m-po-7", document_number: "OC-SIM-55001" }],
  },
  {
    id: "mock-archived-1",
    simulation_name: "Histórico Q1 (archivado)",
    status: "archived",
    created_at: "2026-02-10T10:00:00.000Z",
    executed_at: "2026-02-10T11:00:00.000Z",
    closed_at: "2026-03-01T09:00:00.000Z",
    simulated_purchase_orders: [],
  },
  {
    id: "mock-real-1",
    simulation_name: "Seguimiento escenario real — planta norte",
    status: "real",
    created_at: "2026-01-15T07:30:00.000Z",
    executed_at: "2026-01-15T08:00:00.000Z",
    closed_at: null,
    simulated_purchase_orders: [
      { id: "m-po-8", document_number: "OC-REAL-22091" },
      { id: "m-po-9", document_number: "OC-REAL-22092" },
      { id: "m-po-10", document_number: "OC-REAL-22093" },
      { id: "m-po-11", document_number: "OC-REAL-22094" },
      { id: "m-po-12", document_number: "OC-REAL-22095" },
    ],
  },
  {
    id: "mock-completed-2",
    simulation_name: "Simulación express — categoría A",
    status: "completed",
    created_at: "2026-04-22T13:25:00.000Z",
    executed_at: "2026-04-22T13:28:00.000Z",
    closed_at: "2026-04-22T18:00:00.000Z",
    simulated_purchase_orders: [{ id: "m-po-13", document_number: "OC-SIM-60288" }],
  },
];
